<template>
  <section :id="data.id" class="bg-gray-lighten3 py-6 xl:py-8">
    <div class="container">
      <p class="caption sm:max-w-[664px]" v-html="data.text" />
    </div>
  </section>
</template>

<script setup lang="ts">
interface Props {
  data?: any;
}

withDefaults(defineProps<Props>(), {
  data: () => ({}),
});
</script>

<style lang="scss" scoped>
p {
  &::before {
    content: '*';
    vertical-align: top;
  }
}
</style>
